import apiClient from '../clients/apiClient';

export interface PlPolicyItem {
    id: number;
    policy_name_ln1?: string | null;
    policy_name_ln2?: string | null;
    policy_name_ln3?: string | null;
    pl_policy_type_id?: number | null;
}

const policyService = {
    getPoliciesByType: async (typeId: number): Promise<PlPolicyItem[]> => {
        try {
            const response = await apiClient.get<PlPolicyItem[]>('/pl_policy/', { params: { type_id: typeId } });
            return response.data || [];
        } catch (error: any) {
            throw new Error(error.response?.data?.detail || 'Failed to retrieve policies');
        }
    }
};

export default policyService;
